export const UserAuthState = {
	url: '/auth?org',
	title: 'Auth',
	// autoLogin: set when redirected from user.logout to start the Auth0 flow without a button click
	params: {org: null, autoLogin: null},
	template: '<auth-page></auth-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userAuthPageMod" */
			'@Containers/user-auth-page/user-auth-page.cmp.js'
		)
			.then(m => $ocLazyLoad.load({name: m.default}))
			.catch(err => $log.error(err));
	},
};
